import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import moment from 'moment';
import 'moment/locale/pt-br';

import { Fragment, Suspense } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ptBR } from '@mui/x-date-pickers/locales';
import { ThemeProvider } from '@mui/material';
import { AuthProvider } from './contexts/context';

moment.locale('pt-br');

import './App.css';

const RoutesApp = React.lazy(() => import("./routes"));
const WorkState = React.lazy(() => import("./components/layouts/workstate"));

import ThemesApp from './components/themes';

const App = ({ children }) => {

  return (
    <Fragment>
      <ThemeProvider theme={ThemesApp}>
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale={ptBR}
          localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}>
          <RoutesApp >
            <AuthProvider>
              <CssBaseline />
              <Suspense fallback={<WorkState />}>
                {children}
              </Suspense>
            </AuthProvider>
          </RoutesApp>
        </LocalizationProvider>
      </ThemeProvider>
    </Fragment>
  );
};

export default App;
